import { render, staticRenderFns } from "./PsiDetailRecurrencies.vue?vue&type=template&id=55eab544&scoped=true"
import script from "./PsiDetailRecurrencies.vue?vue&type=script&lang=js"
export * from "./PsiDetailRecurrencies.vue?vue&type=script&lang=js"
import style0 from "./PsiDetailRecurrencies.vue?vue&type=style&index=0&id=55eab544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eab544",
  null
  
)

export default component.exports